import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/archivo/wght.css';
import '@fontsource/cormorant-garamond/500-italic.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const container = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Vorgerenderte Seiten (scripts/prerender.js) werden hydriert, sonst normal gerendert
if (container.hasChildNodes()) {
  ReactDOM.hydrateRoot(container, app);
} else {
  ReactDOM.createRoot(container).render(app);
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
